if (!customElements.get('product-songs')) {
  customElements.define(
    'product-songs',
    class ProductSongs extends HTMLElement {
      connectedCallback() {
        this.rows = Array.from(this.querySelectorAll('[data-song]'));
        this.rows.forEach((row) => this.setupRow(row));
      }

      disconnectedCallback() {
        this.rows && this.rows.forEach((row) => row.querySelector('[data-song-audio]').pause());
      }

      setupRow(row) {
        const audio = row.querySelector('[data-song-audio]');
        const toggle = row.querySelector('[data-song-toggle]');
        const range = row.querySelector('[data-song-range]');
        const current = row.querySelector('[data-song-current]');
        const duration = row.querySelector('[data-song-duration]');

        if (!audio || !toggle) return;

        toggle.addEventListener('click', () => {
          audio.paused ? this.play(row, audio) : audio.pause();
        });

        audio.addEventListener('play', () => {
          this.pauseOthers(audio);
          row.classList.add('is-playing', 'is-active');
          range && range.removeAttribute('tabindex');
        });

        audio.addEventListener('playing', () => row.classList.remove('is-loading'));
        audio.addEventListener('waiting', () => row.classList.add('is-loading'));
        audio.addEventListener('pause', () => row.classList.remove('is-playing', 'is-loading'));

        audio.addEventListener('ended', () => {
          row.classList.remove('is-playing', 'is-active');
          audio.currentTime = 0;
          this.setProgress(range, 0);
          if (current) current.textContent = this.formatTime(0);
          range && range.setAttribute('tabindex', '-1');
        });

        audio.addEventListener('loadedmetadata', () => {
          if (duration) duration.textContent = this.formatTime(audio.duration);
        });

        audio.addEventListener('timeupdate', () => {
          if (!audio.duration || this.isScrubbing) return;
          const percent = (audio.currentTime / audio.duration) * 100;
          if (range) range.value = percent;
          this.setProgress(range, percent);
          if (current) current.textContent = this.formatTime(audio.currentTime);
        });

        if (!range) return;

        range.addEventListener('pointerdown', () => {
          this.isScrubbing = true;
        });

        range.addEventListener('input', () => {
          this.setProgress(range, range.value);
          if (audio.duration && current) {
            current.textContent = this.formatTime((range.value / 100) * audio.duration);
          }
        });

        range.addEventListener('change', () => {
          this.isScrubbing = false;
          if (audio.duration) audio.currentTime = (range.value / 100) * audio.duration;
        });
      }

      play(row, audio) {
        row.classList.add('is-loading', 'is-active');
        const played = audio.play();
        played &&
          played.catch(() => {
            row.classList.remove('is-loading', 'is-playing', 'is-active');
          });
      }

      // Only one song plays at a time, across every playlist on the page.
      pauseOthers(audio) {
        document.querySelectorAll('[data-song-audio]').forEach((other) => {
          if (other !== audio && !other.paused) other.pause();
        });
      }

      setProgress(range, percent) {
        range && range.style.setProperty('--song-progress', `${percent}%`);
      }

      formatTime(seconds) {
        if (!seconds || !isFinite(seconds)) return '--:--';
        const minutes = Math.floor(seconds / 60);
        const rest = Math.floor(seconds % 60);
        return `${minutes}:${rest.toString().padStart(2, '0')}`;
      }
    }
  );
}
